import { useTranslation } from 'react-i18next'

import classes from './EnrollmentDetailDrawer.module.scss'

const InactiveMemberNotice = () => {
  const { t } = useTranslation()
  return <p className={classes.inactiveMemberNotice}>{t('enrollmentsBilling.drawer.inactiveMemberNotice')}</p>
}

export default InactiveMemberNotice
